import { generateGuestToken } from '../../../lib/generateGuestToken.ts'
import {
  CartIndexQuerySchema,
  CartIndexSuccessSchema,
  CartUpdatePathSchema,
  CartUpdateSuccessSchema
} from '~/services/api/generated'
import type { CartIndexQuery, CartUpdatePath, CartUpdateRequest } from '~/services/api/generated'
import { CartUpdate } from '~/services/api/contracts/requests/CartUpdate'

export function useCartService() {
  const baseURL = `${useRuntimeConfig().public.apiBaseUrl}/api`
  const sanctumClient = useApiRequest()

  return {
    index: async (token: string | undefined, query: CartIndexQuery) => {
      const parsedQuery = CartIndexQuerySchema.strict().parse({
        ...query,
        guest_token: token ?? generateGuestToken()
      })
      return CartIndexSuccessSchema.parse(
        await sanctumClient(`${baseURL}/cart/`, {
          query: parsedQuery
        })
      )
    },
    update: async (cartItemId: CartUpdatePath['cartItem'], payload: CartUpdateRequest) => {
      const path = CartUpdatePathSchema.strict().parse({ cartItem: cartItemId })
      const request = CartUpdate({}).parse(payload)

      return CartUpdateSuccessSchema.parse(
        await sanctumClient(`${baseURL}/cart/${path.cartItem.toString()}`, {
          method: 'PUT',
          body: request
        })
      )
    }
  }
}
